import React from 'react';
import { Typography } from '@mui/material';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import { DASHBOARD_KEYS } from '../../../../platform/widgets/widgetRegistry.js';
import RoleDashboardPage from './RoleDashboardPage';

/**
 * DH Dashboard — Mindmap branch 3, "Department Head"
 *  - Verifies severity & assigns priority at L2; sees the department and its NWTs
 * The old "Customize View" toggles (P2-25) are now widget presence: remove / add cards with
 * Customize (P3-13). Widgets (B4): dept-scores, l2-queue, nwts-in-dept, comparisons (NWT-to-NWT),
 * what-changed, oe-trend, report-shortcuts, oe-conditions (department + owned, P2-14).
 */
function DHDashboard() {
  return (
    <RoleDashboardPage
      dashboardKey={DASHBOARD_KEYS.drewDh}
      hero={{
        icon: AccountTreeIcon,
        title: 'Department Head Dashboard',
        color: '#6a1b9a',
        caption: (role) => {
          const myNwts = (role.activeOrg?.teams || []).filter((t) => t.departmentId === role.myDept?.id);
          return (
            <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 1 }}>
              Department: <strong>{role.myDept?.name || '—'}</strong> • {myNwts.length} NWT{myNwts.length === 1 ? '' : 's'} • Responsible for severity verification &amp; priority assignment
            </Typography>
          );
        },
      }}
      conditions={{ title: 'OE Conditions', scopeLabel: (role) => (role.myDept?.name ? `${role.myDept.name} — observed here or owned by this department` : 'Department') }}
    />
  );
}

export default DHDashboard;
